export const formatLink = (link: string) => {
  return link
    ?.replace('https://', '')
    .replace('http://', '')
    .replace('www.', '');
};
